import React from "react";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Typography from "@mui/material/Typography";
import facebookIcon from "assets/images/icons/socials/facebook.png";
import Box from "@mui/material/Box";

function InstagramInstructions({ onBack, onProceed }) {
    return (
        <MDBox px={2} pb={2} textAlign="center">
            <Typography variant="body1" mb={2} fontWeight="medium">
                Important: Business Account Required
            </Typography>

            <Typography variant="body2" color="text.secondary" mb={3}>
                To get detailed analytics, your Instagram account must be a <b>Business Account</b> and linked to a Facebook Page.
            </Typography>

            <Typography variant="body2" color="text.secondary" mb={3}>
                If you haven&apos;t done this yet, please go to your Instagram settings and link it to a Facebook Page before proceeding.
            </Typography>

            <MDBox display="flex" justifyContent="center" gap={2} mt={3}>
                <MDButton variant="outlined" color="info" onClick={onBack}>
                    Back
                </MDButton>
                <MDButton
                    variant="contained"
                    color="accent"
                    // startIcon={<Box component="img" src={facebookIcon} sx={{ width: 20, height: 20 }} />}
                    onClick={onProceed}
                >
                    Proceed Now
                </MDButton>
            </MDBox>
        </MDBox>
    );
}

export default InstagramInstructions;
